import gsap from 'gsap';


export default class Topics{

    constructor(){
        this._init();
    }


    _init(){
        this.BREAK_POINT_PC = 'only screen and (min-width: 769px)';
        this.bp = '';

        this.$topics = document.querySelector('.topics');
        this.$main = document.querySelector('.topics__main');
        this.$btn = document.querySelector('.topics__more');
        this.itemlist = [...document.querySelectorAll('.topics__list__row')];

        if(this.itemlist.length > 4){
            window.matchMedia(this.BREAK_POINT_PC).addListener(this._changeBreakPoint.bind(this));
            this._changeBreakPoint();
            this._setUI();
        }
    }

    _changeBreakPoint(){
        if(window.matchMedia(this.BREAK_POINT_PC).matches) this.bp = 'pc';
        else this.bp = 'sp';
    }


    _setUI(){
        this.$btn.classList.add('-active');

        this.$btn.addEventListener('click', ()=>{

            if(this.$topics.classList.contains('-opened')){
                this.$topics.classList.remove('-opened');

                const close_h = this.bp=='pc' ? 350 : 360;
                gsap.to(this.$main, {duration: 0.3, maxHeight: close_h});
            }
            else{
                const open_h = document.querySelector('.topics__list').getBoundingClientRect().height;
                gsap.to(this.$main, {duration:0.5, maxHeight: open_h});
                this.$topics.classList.add('-opened');
            }
        });
    }
}
